import { FC, useState } from 'react'

import styled from 'styled-components'
import { Modal } from 'antd'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import { VideoPlayer } from 'src/Components/VideoPlayer'

const StyledModal = styled(Modal)`
  max-width: 600px;
  width: 100% !important;

  .ant-modal-body {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    gap: 0;
    position: relative !important;
    padding: 0;
  }

  .ant-modal-content {
    width: 100% !important;
    padding: 0;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background-color: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.card};
    overflow: hidden;
  }

  .ant-modal-close-icon {
    svg {
      path {
        fill: ${({ theme }) => theme.color.darkGrey};
      }
    }
  }
`

const Header = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 12px 8px 12px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ theme }) => theme.color.white};
`

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

const Title = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: ${variables.fontWeight600};
  font-size: 16px;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
`

const Subtitle = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize14};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
`

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background-color: ${({ theme }) => theme.color.white};

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: column;
    gap: 32px;
    overflow-y: auto;
    max-height: calc(100vh - 150px);
  }
`

const StyledVideoPlayer = styled(VideoPlayer)`
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
    height: 587px;
    flex-shrink: 0;
  }
`

interface VideoExamplesModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  videoUrls: string[]
}

export const VideoExamplesModal: FC<VideoExamplesModalProps> = ({
  isOpen,
  onClose,
  title,
  videoUrls,
}) => {
  const [playingIndex, setPlayingIndex] = useState<number | null>(null)

  const handleClose = (): void => {
    setPlayingIndex(null)
    onClose()
  }

  return (
    <StyledModal
      open={isOpen}
      footer={null}
      centered
      onCancel={handleClose}
      closable
    >
      <Header>
        <HeaderText>
          <Title>{title}</Title>
          <Subtitle>
            See how creators typically use this format to promote music.
          </Subtitle>
        </HeaderText>
      </Header>
      <Content>
        {videoUrls.map((url, index) => (
          <StyledVideoPlayer
            key={url + String(index)}
            videoUrl={url}
            paused={
              !isOpen || (playingIndex !== null && playingIndex !== index)
            }
            onPlay={() => setPlayingIndex(index)}
          />
        ))}
      </Content>
    </StyledModal>
  )
}
